<template>
  <modal @close="$emit('close')" class="preview-modal">
    <div slot="header">
      <h4>Follow up Email Preview</h4>
    </div>
    <div slot="body">
      <div class="row mb-1">
        <div class="col-6 pr-1">
          <div class="select-wrap">
            <label>Email</label>
            <p>{{ followUp.customer_email }}</p>
          </div>
        </div>
        <div class="col-6 pl-1" />
      </div>
      <div class="row mb-1">
        <div class="col-6 pr-1">
          <div class="select-wrap">
            <label>Subject</label>
            <p>{{ followUp.subject }}</p>
          </div>
        </div>
        <div class="col-6 pl-1" />
      </div>
      <div class="row mb-2">
        <div class="col">
          <div class="select-wrap email-body-preview">
            <label>Email body</label>
            <p v-dompurify-html="followUp.body" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <p>{{ followUp.date }}</p>
        </div>
      </div>
    </div>
    <div slot="footer">
      <p />
    </div>
  </modal>
</template>

<script>
import axios from 'axios';
import Errors from '../../../classes/Errors';
import Modal from '../../Modal';

export default {
  components: {
    Modal,
  },
  props: {
    lead: {
      type: Object,
      default: null,
    },
    followUpId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    followUp: {
      body: '',
      subject: '',
      customer_email: '',
      date: '',
    },
    loadingButton: false,
    errors: new Errors(),
  }),
  mounted() {
    this.getFollowUp();
  },
  methods: {
    getFollowUp() {
      axios
        .get(`leads/${this.lead.id}/follow-ups/${this.followUpId}`)
        .then(result => {
          this.followUp = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/leads/followUps/PreviewEmail.vue